import Responses from "./Responses";
export default Responses;
